import moment from "moment";

/**
 * A period option's grain and key, in the viewer's zone — what the period
 * picker needs to list comparable periods and name the comparison it sends
 * the server (which keys periods the same way, in the zone the request
 * declares).
 */
const GRAIN_FORMAT = { month: "YYYY-MM", week: "GGGG-[W]WW", year: "YYYY" };
const GRAIN_UNIT = { month: "month", week: "isoWeek", year: "year" };
const GRAIN_STEP = { month: "month", week: "week", year: "year" };

// Same period-value → grain reading as previousWindowFor (LeadingCategoryTrend).
export const periodGrain = (period) => {
  const v = period?.value || "";
  if (/^month_|_month$/.test(v)) return "month";
  if (/^year_|_year$/.test(v)) return "year";
  if (/_week$/.test(v)) return "week";
  return null;
};

// A period option's key at its own grain ("2026-08" for August).
export const periodKey = (period) => {
  const grain = periodGrain(period);
  return grain && period?.from ? moment(period.from).format(GRAIN_FORMAT[grain]) : null;
};

// The key of the period immediately BEFORE the given one, at its own grain
// (the month before a month, the week before a week) — whether or not it
// holds any observations.
export const previousPeriodKey = (period) => {
  const grain = periodGrain(period);
  if (!grain || !period?.from) return null;
  return moment(period.from).startOf(GRAIN_UNIT[grain]).subtract(1, GRAIN_STEP[grain]).format(GRAIN_FORMAT[grain]);
};

export const keyLabel = (key, grain) => {
  if (grain === "month") return moment(key, "YYYY-MM").format("MMM 'YY");
  if (grain === "week") return key.replace(/^(\d{4})-W(\d{2})$/, "wk $2 '$1").replace("'20", "'");
  return key;
};
